// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__BeYVb","title":"ClientInsurance_title__2sS3v","itemText":"ClientInsurance_itemText__3aPtk"};